import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ClientLayout from '../../layouts/ClientLayout';
import PhoneInput from 'react-phone-number-input';


const BecomeSeller = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  // Données pour le formulaire des informations personnelles
  const [personalInfo, setPersonalInfo] = useState({
    fullName: '',
    email: '',
    phone: '',
    additionalPhone: ''
  });

  // Données pour le formulaire des informations de la boutique
  const [storeInfo, setStoreInfo] = useState({
    storeName: '',
    storeAddress: '',
    mainCategory: '',
    deliveryZone: ''
  });

  // Données pour le formulaire des documents de vérification
  const [verificationDocs, setVerificationDocs] = useState({
    identificationNumber: '',
    cniDocument: null,
    selfieDocument: null
  });

  const handlePersonalInfoChange = (e) => {
    setPersonalInfo({
      ...personalInfo,
      [e.target.name]: e.target.value
    });
  };

  const handleStoreInfoChange = (e) => {
    setStoreInfo({
      ...storeInfo,
      [e.target.name]: e.target.value
    });
  };

  const handleVerificationDocsChange = (e) => {
    setVerificationDocs({
      ...verificationDocs,
      [e.target.name]: e.target.value
    });
  };

  const handleFileUpload = (e, field) => {
    const file = e.target.files[0];
    setVerificationDocs({
      ...verificationDocs,
      [field]: file
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const allData = {
      personalInfo,
      storeInfo,
      verificationDocs
    };
    console.log('Formulaire soumis:', allData);
    // Afficher le message de succès
    setIsSubmitted(true);
  };

  const tabs = [
    { id: 0, name: 'Informations personnelles' },
    { id: 1, name: 'Informations sur la boutique' },
    { id: 2, name: 'Documents de vérification' }
  ];

  return (
    <ClientLayout>
       
      <div className="py-8">
        {/* Breadcrumb */}
        <div className="flex-1 md:mx-8 lg:mx-16 mx-auto mb-6">
          <nav className="text-sm text-gray-600">
            <Link to="/" className="hover:text-gray-900">Accueil</Link>
            <span className="mx-2">&gt;</span>
            <span className="text-gray-900">Devenir vendeur</span>
          </nav>
        </div>

        <div className="relative">
          <img src="/images/become-seller.png" alt="become-seller"  className="h-auto" />
          <div className="w-full h-full flex flex-row justify-center">
            <div className='max-w-4xl -mt-[460px]'>
            <div className="flex flex-col justify-center h-full ">
             <div className='flex flex-row justify-between'>
              <div className='flex flex-col gap-6 lg:w-2/3 mt-12 w-full'>
                <h1 className='text-white text-3xl font-extrabold'>Devenez vendeur sur Kilimmanjaro et doublez vos ventes en un éclaire</h1>
                <p className='text-white text-base font-light'>
                Rejoignez Kilimmanjaro, la marketplace panafricaine qui connecte votre boutique à des milliers de clients. Créez votre espace vendeur, gérez vos produits et recevez vos paiements en toute sécurité.
                </p> 
                <button onClick={() => navigate('/vendor/login')} className='w-[fit-content] bg-white font-semibold text-orange-hover text-sm px-6 py-2.5 rounded-full hover:bg-gray-100 transition-colors'>
                  Se connecter comme un vendeur
                </button>
             </div> 
             <img src="/images/affaires-noir-expression-heureuse.png" alt="become-seller-2" className='w-1/3 h-auto' />
             </div>

             {!isSubmitted ? (
               <form onSubmit={handleSubmit} className='shadow-lg flex flex-col gap-4 bg-white w-full rounded-lg px-8 py-10 mt-0'>
                {/* Navigation des tabs */}
                <div className='flex flex-row justify-between gap-6 text-gray-500 mb-4'>
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      type="button"
                      onClick={() => setActiveTab(tab.id)}
                      className={`border-b-2 pb-1.5 text-lg transition-colors ${
                        activeTab === tab.id 
                          ? 'border-gray-700 text-gray-700 font-semibold' 
                          : 'border-gray-300 text-gray-500 hover:text-gray-700'
                      }`}
                    >
                      {tab.name}
                    </button>
                  ))}
                </div>

              {/* Formulaire des informations personnelles */}
              {activeTab === 0 && (
                    <div className='w-full'>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className='col-span-1'>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Nom complet *
                          </label>
                          <input
                            type="text"
                            name="fullName"
                            value={personalInfo.fullName}
                            onChange={handlePersonalInfoChange}
                            placeholder="Nom complet"
                            className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-hover focus:border-transparent"
                            required
                          />
                        </div>

                        <div className='col-span-1'>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Email *
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={personalInfo.email}
                            onChange={handlePersonalInfoChange}
                            placeholder="Email"
                            className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-hover focus:border-transparent"
                            required
                          />
                        </div>

                        <div className='col-span-1'>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Téléphone *
                          </label>
                          <PhoneInput
                            international
                            defaultCountry="TG"
                            value={personalInfo.phone}
                            onChange={handlePersonalInfoChange}
                            placeholder="Entrez votre numéro"
                            className="w-full px-4 py-1.5 pr-0 border rounded-lg bg-gray-50 focus:border-transparent"
                          />
                        </div>
                        <div className='col-span-1'>
                          <div className='flex flex-row justify-between items-center h-full'>
                            <span className='text-orange-hover text-sm font-semibold'> + Ajouter un autre numéro de téléphone</span>
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-end mt-20'>
                        <button
                          type="button"
                          onClick={() => setActiveTab(1)}
                          className="bg-orange-hover text-white px-12 py-2 rounded-full hover:bg-orange-700 transition-colors"
                        >
                          Suivant
                        </button>
                      </div>
                    </div>
              )}

              {/* Formulaire des informations sur la boutique */}
              {activeTab === 1 && (
                <div className="flex flex-col gap-4">
                  {/* Logo de l'entreprise */}
                  <div className="flex justify-center">
                    <div className="w-20 h-20 bg-gray-200 rounded-full flex items-center justify-center">
                      <svg className="w-10 h-10 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <p className="text-center text-gray-600 font-semibold mb-4">Logo de l'entreprise</p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Nom de la boutique *
                      </label>
                      <input
                        type="text"
                        name="storeName"
                        value={storeInfo.storeName}
                        onChange={handleStoreInfoChange}
                        placeholder="Nom complet"
                        className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-hover focus:border-transparent"
                        required
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Catégorie principale *
                      </label>
                      <select
                        name="mainCategory"
                        value={storeInfo.mainCategory}
                        onChange={handleStoreInfoChange}
                        className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-hover focus:border-transparent"
                        required
                      >
                        <option value="">Catégorie principale</option>
                        <option value="electronique">Électronique</option>
                        <option value="vetements">Vêtements</option>
                        <option value="alimentation">Alimentation</option>
                        <option value="maison">Maison & Jardin</option>
                        <option value="sport">Sport & Loisirs</option>
                        <option value="beaute">Beauté & Santé</option>
                      </select>
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Adresse de la boutique
                      </label>
                      <input
                        type="text"
                        name="storeAddress"
                        value={storeInfo.storeAddress}
                        onChange={handleStoreInfoChange}
                        placeholder="Adresse de la boutique"
                        className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-hover focus:border-transparent"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Zone de livraison (optionnel)
                      </label>
                      <select
                        name="deliveryZone"
                        value={storeInfo.deliveryZone}
                        onChange={handleStoreInfoChange}
                        className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-hover focus:border-transparent"
                      >
                        <option value="">Select</option>
                        <option value="lome">Lomé</option>
                        <option value="kara">Kara</option>
                        <option value="sokode">Sokodé</option>
                        <option value="kpalime">Kpalimé</option>
                        <option value="atakpame">Atakpamé</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="flex justify-between mt-20">
                    <button
                      type="button"
                      onClick={() => setActiveTab(0)}
                      className="bg-gray-400 text-white px-12 py-2 rounded-full hover:bg-gray-600 transition-colors"
                    >
                      Précédent
                    </button>
                    <button
                      type="button"
                      onClick={() => setActiveTab(2)}
                      className="bg-orange-hover text-white px-12 py-2 rounded-full hover:bg-orange-700 transition-colors"
                    >
                      Suivant
                    </button>
                  </div>
                </div>
              )}

              {/* Formulaire des documents de vérification */}
              {activeTab === 2 && (
                <div className="flex flex-col gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Numéro d'identification (CNI / Passeport / RCCM) *
                    </label>
                    <input
                      type="text"
                      name="identificationNumber"
                      value={verificationDocs.identificationNumber}
                      onChange={handleVerificationDocsChange}
                      placeholder="Numéro d'identification"
                      className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-hover focus:border-transparent"
                      required
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Photo du document CNI
                    </label>
                    <div className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center hover:border-orange-hover transition-colors">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileUpload(e, 'cniDocument')}
                        className="hidden"
                        id="cni-upload"
                      />
                      <label htmlFor="cni-upload" className="cursor-pointer">
                        <div className="text-4xl text-gray-400 mb-2">+</div>
                        <p className="text-gray-600">Ajouter une pièce jointe</p>
                      </label>
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Photo personnelle (selfie avec document)
                    </label>
                    <div className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center hover:border-orange-hover transition-colors">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileUpload(e, 'selfieDocument')}
                        className="hidden"
                        id="selfie-upload"
                      />
                      <label htmlFor="selfie-upload" className="cursor-pointer">
                        <div className="text-4xl text-gray-400 mb-2">+</div>
                        <p className="text-gray-600">Ajouter une pièce jointe</p>
                      </label>
                    </div>
                  </div>
                  
                  <div className="flex justify-between mt-20">
                    <button
                      type="button"
                      onClick={() => setActiveTab(1)}
                      className="bg-gray-400 text-white px-12 py-2 rounded-full hover:bg-gray-600 transition-colors"
                    >
                      Précédent
                    </button>
                    <button
                      type="submit"
                      className="bg-orange-hover text-white px-12 py-2 rounded-full hover:bg-orange-700 transition-colors"
                    >
                      Envoyer
                    </button>
                  </div>
                </div>
              )}
               </form>
             ) : (
               /* Message de succès */
               <div className='shadow-lg flex flex-col gap-4 bg-white w-full rounded-lg px-8 py-10 mt-0'>
                 {/* Navigation des tabs (inactifs) */}
                 <div className='flex flex-row justify-between gap-6 text-gray-400 mb-8'>
                   {tabs.map((tab) => (
                     <div
                       key={tab.id}
                       className="border-b-2 border-gray-300 pb-1.5 text-lg"
                     >
                       {tab.name}
                     </div>
                   ))}
                 </div>

                 {/* Illustration de succès */}
                 <div className="flex justify-center mb-8">
                    <img src="/svg/hi-five.svg" alt="success" className="w-44 h-auto" />
                 </div>

                 {/* Message de succès */}
                 <div className="text-center mb-8 w-2/3 mx-auto">
                   <p className="text-gray-700 text-base font-medium leading-relaxed">
                     Votre demande a été soumise avec succès, vous serez contacté d'ici peu pour la suite de la procédure.
                     L'équipe Kilimmanjaro vous remercie.
                   </p>
                 </div>

                 {/* Bouton retour à l'accueil */}
                 <div className="flex justify-center">
                   <button
                     onClick={() => navigate('/')}
                     className="bg-orange-hover text-white px-12 py-2 rounded-full hover:bg-orange-700 transition-colors font-medium"
                   >
                     Retour à l'accueil
                   </button>
                 </div>
               </div>
             )}
            </div>
            </div>
          </div>
        </div>
        
    </div>
    </ClientLayout>
  );
};

export default BecomeSeller;
